import { RoomBaseApiService } from "./room.baseapi.service";
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class RoomStickerService extends RoomBaseApiService {

  async changeRoomUserSticker(params) {
    try {
      await this.request().patch(
        `/api/v3/room/${this.getRoomId()}/users/${params.userId}/stickers`, { ...params }
      )
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeAllRoomUserSticker(params) {
    try {
      await this.request().patch(
        `/api/v3/room/${this.getRoomId()}/users/stickers`, { ...params }
      )
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

}

export const roomStickerService = new RoomStickerService();